(function () {
  'use strict';

  angular
    .module('crewPairingReport')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('crewPairingReport', {
        url: '/crew-pairing-report',
        views : {
          'crewPairingReportView' : {
            templateUrl: 'crew-pairing-report/views/crew-pairing-report.tpl.html',
            controller: 'CrewPairingReportCtrl',
            controllerAs: 'crewPairingReport'
          }
        }
      });
  }
}());
